var _path, _path2, _path3, _path4, _path5, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 25,
    viewBox: "0 0 26 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.41609 3.35222C5.41609 1.64579 6.79942 0.262451 8.50586 0.262451C10.2123 0.262451 11.5956 1.64579 11.5956 3.35222C11.5956 5.05866 10.2123 6.44199 8.50586 6.44199C6.79942 6.44199 5.41609 5.05866 5.41609 3.35222ZM8.50586 1.94778C7.73021 1.94778 7.10142 2.57657 7.10142 3.35222C7.10142 4.12787 7.73021 4.75666 8.50586 4.75666C9.28151 4.75666 9.9103 4.12787 9.9103 3.35222C9.9103 2.57657 9.28151 1.94778 8.50586 1.94778Z",
    fill: "url(#paint0_linear_5222_4995)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.44744 7.56555H8.56429C9.57377 7.56551 10.4156 7.56549 11.0838 7.65533C11.7892 7.75017 12.426 7.95878 12.9378 8.47052C13.4495 8.98227 13.6581 9.6191 13.753 10.3245C13.8428 10.9927 13.8428 11.8345 13.8427 12.844L13.8427 13.4642C13.8427 13.9296 13.4655 14.3069 13.0001 14.3069C12.5347 14.3069 12.1574 13.9296 12.1574 13.4642V12.9024C12.1574 11.8193 12.1556 11.0917 12.0827 10.549C12.0129 10.0305 11.8925 9.80865 11.7461 9.66223C11.5996 9.51581 11.3777 9.39534 10.8593 9.32563C10.3165 9.25267 9.58898 9.25088 8.50586 9.25088C7.42274 9.25088 6.69517 9.25267 6.15246 9.32563C5.63398 9.39534 5.41208 9.51581 5.26566 9.66223C5.11925 9.80865 4.99878 10.0305 4.92907 10.549C4.8561 11.0917 4.85431 11.8193 4.85431 12.9024V13.4642C4.85431 13.9296 4.47704 14.3069 4.01165 14.3069C3.54626 14.3069 3.16898 13.9296 3.16898 13.4642L3.16898 12.844C3.16895 11.8345 3.16892 10.9927 3.25877 10.3245C3.3536 9.6191 3.56221 8.98227 4.07396 8.47052C4.5857 7.95878 5.22253 7.75017 5.92789 7.65533C6.59616 7.56549 7.43796 7.56551 8.44744 7.56555Z",
    fill: "url(#paint1_linear_5222_4995)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.08094 16.3421C1.23932 16.1224 1.49368 15.9922 1.76455 15.9922H10.753C11.1157 15.9922 11.4377 16.2243 11.5524 16.5684L13.6074 22.7335H17.4943C17.9597 22.7335 18.337 23.1108 18.337 23.5762C18.337 24.0416 17.9597 24.4188 17.4943 24.4188H4.01165C3.64894 24.4188 3.32693 24.1867 3.21223 23.8427L0.965124 17.1013C0.879468 16.8444 0.922561 16.5619 1.08094 16.3421ZM11.8309 22.7335L10.1456 17.6775H2.93368L4.61901 22.7335H11.8309Z",
    fill: "url(#paint2_linear_5222_4995)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.6178 10.3744C16.9114 10.3744 15.5281 11.7578 15.5281 13.4642C15.5281 15.1706 16.9114 16.554 18.6178 16.554C20.3243 16.554 21.7076 15.1706 21.7076 13.4642C21.7076 11.7578 20.3243 10.3744 18.6178 10.3744ZM17.2134 13.4642C17.2134 12.6885 17.8422 12.0598 18.6178 12.0598C19.3935 12.0598 20.0223 12.6885 20.0223 13.4642C20.0223 14.2399 19.3935 14.8686 18.6178 14.8686C17.8422 14.8686 17.2134 14.2399 17.2134 13.4642Z",
    fill: "url(#paint3_linear_5222_4995)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2472 17.6775C14.7818 17.6775 14.4045 18.0548 14.4045 18.5202C14.4045 18.9856 14.7818 19.3629 15.2472 19.3629H21.9885C22.7641 19.3629 23.3929 19.9916 23.3929 20.7673V21.3291C23.3929 22.1047 22.7641 22.7335 21.9885 22.7335H20.8649C20.3996 22.7335 20.0223 23.1108 20.0223 23.5762C20.0223 24.0416 20.3996 24.4188 20.8649 24.4188H21.9885C23.6949 24.4188 25.0783 23.0355 25.0783 21.3291V20.7673C25.0783 19.0609 23.6949 17.6775 21.9885 17.6775H15.2472Z",
    fill: "url(#paint4_linear_5222_4995)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5222_4995",
    x1: 13.0001,
    y1: 0.262451,
    x2: 13.0001,
    y2: 24.4188,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C7BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#33F7BE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5222_4995",
    x1: 13.0001,
    y1: 0.262451,
    x2: 13.0001,
    y2: 24.4188,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C7BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#33F7BE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_5222_4995",
    x1: 13.0001,
    y1: 0.262451,
    x2: 13.0001,
    y2: 24.4188,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C7BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#33F7BE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_5222_4995",
    x1: 13.0001,
    y1: 0.262451,
    x2: 13.0001,
    y2: 24.4188,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C7BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#33F7BE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_5222_4995",
    x1: 13.0001,
    y1: 0.262451,
    x2: 13.0001,
    y2: 24.4188,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C7BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#33F7BE"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/Icon.090cb2625c15adf9af0c852372d8ee26.svg";
export { ForwardRef as ReactComponent };